import React, { useState, useEffect } from 'react';
import parse from 'html-react-parser';
import VideoModal from '../VideoModal';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Hero({
  
  title,
  titleTwo,
  subTitle,
  bgColor,
  imgUrl,
  imgUrlMobile,
  videoBtnText,
  videoUrl,
  infoList,
  btnText,
  btnUrl,
}) {
  const { t, ready } = useTranslation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!ready) {
    return null;
  }

  return (
    <>
      {/* CSS inline dentro del componente */}
      <style>{`
         .hero {
          width: 100%;
          height: 360px;
          display: block;
          background-image: url(/images/home_1/familia_gestacion_opt.webp);
          background-size: contain;
          background-position: bottom;
          background-repeat: no-repeat;

        }
        @media (max-width: 600px) {
          .hero {
            height: 311px;
            background-image: url(/images/home_1/familia_gestacion_opt_movil.webp);
          }
        }

        .cs_random_features {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: flex-start;
          gap: 15px 110px;
          justify-content: center;
          @media (max-width: 1700px) {
            gap: 15px 60px;
          }
          @media (max-width: 1380px) {
            gap: 15px 24px;
          }
          @media (max-width: 1121px) {
            gap: 24px;
            align-items: initial;
          }

        .cs_random_features_col {
          padding-top: 30px;
          margin-top: 10px;
          @media (max-width: 1700px) {
            padding-top: 45px;
            margin-top: 30px;
          }
          @media (max-width: 1380px) {
            padding-top: 25px;
          }
          @media (max-width: 1121px) {
            padding-top: 0px;
          }
          @media (max-width: 767px) {
            width: 100%;
          }
          &:nth-child(2) {
            padding-top: 0;
          }
        }
        @media (min-width: 992px) {
          .cs_iconbox.cs_style_13 {
            max-width: 390px;
          }
        }
      }

        .cs_hero.cs_style_1 {
          height: 800px;
          position: relative;
          
          @media (max-width: 1700px) {
            height: 100%;
          }
          @media (max-width: 1480px) {
            height: 100%;
          }
          @media (max-width: 1380px) {
            height: 100%
          }
          @media (max-width: 1300px) {
            height: 100%
          }
          @media (max-width: 1199px) {
            height: 100%
          }
          @media (max-width: 991px) {
            height: 100%
          }
          @media (max-width: 768px) {
            height: 100%
          }
          @media (max-width: 575px) {
            height: 100%
          }
          .cs_hero_text {
            position: relative;
            z-index: 1;
            padding: 3rem;
            @media (max-width: 900px) {
              padding-top: 40px;
            }
            @media (max-width: 576px) {
              padding: 100px 15px; /* Aún más reducido para móviles pequeños */
            }
            
          }
          
          .cs_hero_wrap {
            height: 60%;
            width: 100%;
            padding-top: 160px;
            position: relative;
            @media (max-width: 1300px) {
              padding-top: 120px;
            }
            @media (max-width: 1199px) {
              padding-top: 100px;
              padding-left: 15px;
            }
            @media (max-width: 991px) {
              padding-top: 80px;
            }
            @media (max-width: 768px) {
              padding-top: 60px;
            }
            > .container {
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            }
          }
          .cs_hero_title {
            margin-bottom: 2px;
            max-width: 900px;
            @media (max-width: 1700px) {
              max-width: 710px;
            }
            @media (max-width: 1199px) {
              max-width: 580px;
            }
            @media (max-width: 1199px) {
              margin-bottom: 5px;
            }
          }
          .cs_hero_subtitle {
            max-width: 700px;
            margin-bottom: 60px;
            @media (max-width: 1700px) {
              max-width: 600px;
              margin-bottom: 50px;
            }
            @media (max-width: 1199px) {
              max-width: 580px;
              margin-bottom: 40px;
            }
            @media (max-width: 991px) {
              margin-bottom: 30px;
            }
            @media (max-width: 768px) {
              margin-bottom: 25px;
            }
          }

          .cs_hero_info_wrap {
            padding: 30px 160px;
            margin-bottom: 120px;
            flex-wrap: wrap;
            display: flex;
            justify-content: space-evenly;
            align-items: center;
            gap: 30px;
            position: relative;
            z-index: 1;
            @media (max-width: 1700px) {
              padding: 70px;
              margin-bottom: 100px;
            }
            @media (max-width: 1199px) {
              padding: 70px 25px;
              gap: 24px;
              margin-bottom: 90px;
            }
            @media (max-width: 991px) {
              justify-content: center;
              margin-bottom: 80px;
            }
            @media (max-width: 767px) {
              justify-content: space-between;
              margin-bottom: 70px;
            }
            @media (max-width: 575px) {
              flex-direction: column;
              align-items:flex-start;
              padding: 1rem;
              gap: 10px;
              width: 100%; 
            
            }

          }


          .cs_hero_info_title {
            font-size: 16px;
            line-height: 1.6em;
            margin-bottom: 4px;
          }
          .cs_hero_info_subtitle {
            line-height: 1.3em;
            margin: 0;
          }
          .cs_hero_info_icon {
            height: 70px;
            width: 70px;
            padding: 18px;
            @media (max-width: 1199px) {
              height: 60px;
              width: 60px;
              padding: 15px;
            }
            @media (max-width: 900px) {
              height: 35px;
              width: 35px;
              padding: 5px;
            }
            img {
              filter: brightness(0) invert(1);
            }
          }
          .cs_hero_info {
            
            gap: 24px;
            @media (max-width: 1199px) {
              gap: 15px;
            }
          }
          .cs_hero_img_container {
            position: absolute;
            bottom: -12px;
            left: 70%;
            transform: translateX(-50%);
            width: 500px;
            height: 620px;
            display: flex;
            align-items: flex-end;
            justify-content: center;
            
            @media (max-width: 1700px) {
              width: 460px;
              height: 580px;
              left: 72%;
            }
            @media (max-width: 1480px) {
              width: 440px;
              height: 560px;
              left: 71%;
            }
            @media (max-width: 1300px) {
              width: 400px;
              height: 520px;
              left: 70%;
            }
            @media (max-width: 1199px) {
              width: 380px;
              height: 480px;
            }
            @media (max-width: 991px) {
              position: relative;
              width: 100%;
              height: 280px;
              left: 50%;
              transform: translateX(-50%);
              margin-top: 20px;
              margin-bottom: -60px;
            }
            @media (max-width: 768px) {
              height: 300px;
              margin-bottom: -50px;
            }
            @media (max-width: 575px) {
              height: 320px;
              margin-bottom: -40px;
            }
          }
          
          .cs_hero_img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            object-position: center bottom;
            display: block;
            
            @media (max-width: 991px) {
              object-position: center;
            }
          }
          .cs_hero_patents {
            position: absolute;
            left: 39.3%;
            top: 58.5%;
            @media (max-width: 1700px) {
              left: 33%;
            }
          }
        }
        .cs_hero.cs_style_2 {
          height: 100vh;
          min-height: 750px;
          max-height: 1080px;
          padding: 218px 0 0;
          position: relative;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          align-items: center;
          background-color: #35546c;
          @media (max-width: 1700px) {
            padding: 190px 0 0;
          }
          @media (max-width: 1380px) {
            padding-top: 170px;
          }
          @media (max-width: 1199px) {
            min-height: initial;
            height: initial;
            max-height: initial;
            padding-top: 150px;
          }
          .cs_hero_text {
            position: relative;
            z-index: 2;
            @media (max-width: 1199px) {
              margin-bottom: 60px;
            }
            @media (max-width: 767px) {
              margin-bottom: 40px;
            }
          }
          > .container {
            &:first-child {
              flex: 1;
              position: relative;
            }
          }
          .cs_hero_bottom {
            display: flex;
            gap: 0 50px;
            min-height: 100px;
            @media (max-width: 1380px) {
              flex-direction: column;
              gap: 40px 0;
            }
          }
          .cs_hero_bottom_left {
            flex: none;
            width: 350px;
            @media (max-width: 1700px) {
              width: 280px;
            }
          }
          .cs_hero_title {
            max-width: 900px;
            margin-bottom: 82px;
            @media (max-width: 1380px) {
              margin-bottom: 50px;
            }
            @media (max-width: 767px) {
              margin-bottom: 20px;
            }
          }
          .cs_hero_text_in {
            display: flex;
            gap: 30px 75px;
            @media (max-width: 767px) {
              flex-direction: column-reverse;
            }
          }
          .cs_hero_subtitle {
            margin: 0;
            max-width: 500px;
          }
          .cs_hero_patents {
            position: absolute;
            top: -75px;
            right: 0;
            z-index: 1;
            animation: anim-y 5s cubic-bezier(0.4, 0, 0.2, 1) infinite;
            @media (max-width: 1380px) {
              top: -40px;
            }
            @media (max-width: 991px) {
              display: none;
            }
          }
          .cs_hero_funfact {
            display: flex;
            max-width: 1210px;
            margin-left: auto;
            position: relative;
            gap: 0 97px;
            justify-content: space-between;
            padding: 57px 0 73px 73px;
            @media (max-width: 1700px) {
              gap: 0 30px;
              padding: 40px 0 50px 60px;
            }
            @media (max-width: 1700px) {
              padding: 30px 0 50px 40px;
            }
            @media (max-width: 991px) {
              flex-wrap: wrap;
              gap: 30px 0px;
              padding: 30px 0 35px 30px;
            }
            @media (max-width: 575px) {
              padding-left: 0;
            }
            &::before {
              content: '';
              position: absolute;
              height: 100%;
              width: 100vw;
              left: 0;
              top: 0;
              border-radius: 25px 0px 0px 0px;
              background: rgba(255, 255, 255, 0.1);
              backdrop-filter: blur(21.5px);
              box-shadow: 0px 0px 0px 1px rgb(255 255 255 / 40%);
            }
            h3 {
              margin-bottom: 8px;
            }
            .cs_hero_funfact_col {
              position: relative;
              z-index: 2;
              @media (max-width: 991px) {
                width: 50%;
                padding: 0 10px;
              }
              @media (max-width: 450px) {
                h3 {
                  font-size: 36px;
                }
              }
            }
          }
          .cs_text_btn_2 {
            &:hover {
              color: #fff;
            }
          }
        }
        .cs_hero.cs_style_2.cs_type_1 {
          background: linear-gradient(
            -89deg,
            #274760 0.95%,
            rgba(39, 71, 96, 0.59) 98.78%
          );
          .cs_hero_funfact {
            background-color: rgba(39, 71, 96, 0.9);
            width: 100%;
            padding: 57px 60px 73px 60px;
            gap: 0 30px;
            border: 1px solid rgba(255, 255, 255, 0.4);
            border-bottom: 0;
            border-radius: 25px 25px 0px 0px;
            @media (max-width: 1700px) {
              padding: 40px 50px 50px 50px;
            }
            @media (max-width: 1199px) {
              padding: 30px 30px 35px 30px;
            }
            @media (max-width: 991px) {
              padding: 30px 0px 35px 0px;
              gap: 30px 0px;
            }
            &:before {
              display: none;
            }
          }
          .cs_hero_text {
            padding-left: 50%;
            @media (max-width: 1400px) {
              padding-left: 42%;
            }
            @media (max-width: 1199px) {
              padding-left: 0%;
            }
            @media (max-width: 420px) {
              .cd-headline {
                display: block;
              }
            }
          }
          .cs_hero_img {
            position: absolute;
            bottom: 0;
            width: 50%;
            text-align: center;
            padding-top: 8%;
            height: 100%;
            padding-left: 15px;
            padding-right: 15px;
            display: flex;
            align-items: flex-end;
            justify-content: flex-start;
            @media (max-width: 1400px) {
              width: 42%;
          
            }
            @media (max-width: 1199px) {
              width: 100%;
              position: initial;
              max-width: 600px;
              padding-top: 0;
            }
            img {
              max-height: 100%;
            }
          }
          .cs_hero_btn {
            flex: none;
          }
          .cs_hero_title {
            span {
              color: $accent;
            }
          }
        }
        .cs_hero.cs_style_3 {
          height: calc(100vh + 235px);
          max-height: 1350px;
          min-height: 1050px;
          position: relative;
          padding-top: 240px;
          overflow: hidden;
          @media (max-width: 1380px) {
            padding-top: 200px;
          }
          @media (max-width: 991px) {
            padding-top: 160px;
            padding-bottom: 400px;
            min-height: calc(100vh + 210px);
            max-height: initial;
            height: initial;
          }
          @media (max-width: 991px) {
            display: flex;
            align-items: center;
          }
          @media (max-width: 575px) {
            padding-top: 140px;
            min-height: initial;
            max-height: initial;
            height: initial;
            .cs_fs_20 {
              font-size: 16px;
            }
          }
          .cs_hero_bg {
            position: absolute;
            height: calc(100% - 235px);
            width: 100%;
            left: 0;
            top: 0;
            display: flex;
            align-items: flex-end;
            @media (max-width: 991px) {
              height: calc(100% - 210px);
            }
          }
          > .container {
            position: relative;
            z-index: 2;
          }
          .cs_hero_title {
            max-width: 1000px;
            margin-bottom: 52px;
            @media (max-width: 1700px) {
              max-width: 750px;
            }
            @media (max-width: 1199px) {
              max-width: 550px;
            }
            @media (max-width: 991px) {
              margin-bottom: 20px;
            }
          }
          .cs_hero_subtitle {
            max-width: 540px;
          }
          .cs_hero_img_1 {
            position: absolute;
            top: 150px;
            right: 90px;
            @media (max-width: 1700px) {
              top: 170px;
              right: 70px;
              max-width: 880px;
            }
            @media (max-width: 1400px) {
              right: 15px;
              margin-left: 15px;
              max-width: 800px;
            }
            @media (max-width: 991px) {
              display: none;
            }
          }
          .cs_hero_img_2 {
            position: absolute;
            right: 5%;
            top: 69%;
            animation: animo-x 7s cubic-bezier(0.4, 0, 0.2, 1) infinite;
            @media (max-width: 1700px) {
              top: 66%;
            }
            @media (max-width: 991px) {
              display: none;
            }
          }
          .cs_hero_img_3 {
            position: absolute;
            right: 38%;
            top: 40%;
            animation: anim-y 5s cubic-bezier(0.4, 0, 0.2, 1) infinite;
            @media (max-width: 1700px) {
              right: 30%;
            }
            @media (max-width: 1400px) {
              top: 50%;
            }
            @media (max-width: 1380px) {
              top: 60%;
              right: 34%;
            }
            @media (max-width: 1199px) {
              display: none;
            }
          }
          .cs_hero_img_4 {
            position: absolute;
            right: 7%;
            top: 24%;
            animation: zoom-anim 7s cubic-bezier(0.4, 0, 0.2, 1) infinite;
            @media (max-width: 991px) {
              display: none;
            }
          }
          .cs_hero_card {
            display: inline-block;
            border-radius: 20px;
            background: linear-gradient(163deg, #86bbf1 0%, #d2eaef 100%);
            padding: 30px 40px;
            position: relative;
            bottom: -100px;
            z-index: 2;
            @media (max-width: 575px) {
              width: 100%;
              padding: 30px 15px;
            }
            @media (max-width: 380px) {
              .cs_fs_24 {
                font-size: 18px;
              }
              .cs_hero_shedule_list li {
                gap: 8px;
              }
            }
          }
          .cs_hero_card_media {
            display: flex;
            align-items: center;
            margin-bottom: 23px;
            img {
              flex: none;
              border-radius: 50%;
              width: 63px;
              height: 63px;
              margin-right: 12px;
              object-fit: cover;
              @media (max-width: 380px) {
                width: 50px;
                height: 50px;
              }
            }
          }
          .cs_hero_shedule_list {
            list-style: none;
            margin: 0;
            padding: 0;
            li {
              display: flex;
              align-items: center;
              gap: 12px;
              &:not(:last-child) {
                margin-bottom: 3px;
              }
            }
            strong {
              font-weight: 600;
            }
          }
          &.cs_type_1 {
            height: 100vh;
            min-height: initial;
            max-height: 1050px;
            @media (max-width: 991px) {
              padding: 150px 0 110px;
            }

            .cs_hero_bg {
              height: 100%;
              &::before {
                content: '';
                position: absolute;
                height: 100%;
                width: 100%;
                left: 0;
                top: 0;
                z-index: 1;
                background: linear-gradient(
                  90deg,
                  #274760 0%,
                  rgba(48, 123, 196, 0) 100%
                );
              }
            }
          }
        }
        .cs_hero.cs_style_4 {
          min-height: 750px;
          position: relative;
          padding: 210px 0 0;
          @media (max-width: 1700px) {
            padding: 190px 0 0;
          }
          @media (max-width: 1199px) {
            padding: 150px 0 0;
          }
          .cs_hero_text {
            max-width: 920px;
            position: relative;
            z-index: 2;
          }
          .cs_hero_title {
            margin-bottom: 40px;
            @media (max-width: 1199px) {
              margin-bottom: 20px;
            }
          }
          .cs_hero_subtitle {
            max-width: 700px;
            margin-bottom: 110px;
            @media (max-width: 1700px) {
              margin-bottom: 60px;
            }
          }
          .cs_hero_img_1 {
            position: absolute;
            left: 53%;
            top: 50%;
            animation: anim-y 5s cubic-bezier(0.4, 0, 0.2, 1) infinite;
            @media (max-width: 991px) {
              display: none;
            }
          }
          .cs_hero_img_2 {
            position: absolute;
            right: 3%;
            bottom: 0%;
            animation: animo-x 7s cubic-bezier(0.4, 0, 0.2, 1) infinite;
            @media (max-width: 991px) {
              display: none;
            }
          }
          .cs_hero_img_3 {
            position: absolute;
            right: 8%;
            top: 22%;
            animation: zoom-anim 7s cubic-bezier(0.4, 0, 0.2, 1) infinite;
            @media (max-width: 991px) {
              display: none;
            }
          }
        }

      `}</style>

      <section className="cs_hero cs_style_1">
        <div
          className="cs_hero_wrap cs_bg_filed"
          style={{ 
            backgroundImage: bgColor, 
            minHeight: '647.75px', 
            position: 'relative', 
            height: '100%'
          }}
        >
          {/* <div className="container"> */}
            <div className="cs_hero_text">
              <span className="cs_hero_title cs_fs_94">{parse(titleTwo)}</span>
              <h1 className="cs_hero_title cs_fs_95">{parse(title)}</h1>
              <p className="cs_hero_subtitle cs_fs_20 text-color-grey">
                {parse(subTitle)}
              </p>
              <div className="cs_hero_btn_wrap">
                <VideoModal
                  videoUrl={t('video_who_we_are')}
                  videoBtnText={videoBtnText}
                  variant="cs_heading_color"
                />
              </div>
            </div>
            <div className="cs_hero_img_container">
              {/* antiguo bloque picture eliminado para optimizar carga de imagen */}
              <div
                  class="hero"
                  role="img"
                  aria-label="Familia gestación"
                ></div>
            </div>
          {/* </div> */}
        </div>
        
        {/* Info section moved outside the main hero wrap */}
         {/* <div className="container_hero">  */}
          <div className="cs_hero_info_wrap cs_shadow_1 cs_white_bg cs_radius_15" 
           style={{ minHeight: '180px', maxWidth: '100%', overflow: 'hidden', display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}
          >
            {infoList.map((item, index) => (
              <div className="cs_hero_info_col" key={index} style={{ width: '100%', maxWidth: '350px', margin: '0 auto', padding: '10px' }}>
                <div className="cs_hero_info d-flex align-items-center" style={{ width: '100%' }}>
                  <div className="cs_hero_info_icon cs_center rounded-circle cs_accent_bg cs_hero_icon_link" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '44px', height: '44px' }}>
                    <a href={item.link} target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                      <img 
                        src={item.iconUrl} 
                        alt="Icon" 
                        width="24" 
                        height="24" 
                        style={{ margin: '0', display: 'block', maxWidth: '100%' }}
                      />
                    </a>
                  </div>
                  <div className="cs_hero_info_right">
                    <h3 className="cs_hero_info_title cs_semibold text-color-dblue">
                      {item.title}
                    </h3>
                    <p className="cs_hero_info_subtitle cs_fs_20 text-color-grey">
                      {item.subTitle}
                    </p>
                    <p className="cs_hero_info_subtitle text-color-dblue">
                      {item.titleTwo}
                    </p>
                  </div>
                </div>
              </div>
            ))}
            
            <div className="cs_hero_info_col" style={{ width: '100%', maxWidth: '300px', margin: '10px auto', padding: '10px', textAlign: 'center' }}>
              <Link to={btnUrl} className="cs_btn cs_style_1" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 'auto', minWidth: '180px' }}>
                <span>{btnText}</span>
                <i style={{ display: 'flex', alignItems: 'center', padding: '0 5px' }}>
                  <img 
                    src="https://dashboard.gestlifesurrogacy.com/images/icons/arrow_white.svg" 
                    alt="Icon" 
                    width="16" 
                    height="16" 
                    style={{ margin: '0 2px' }}
                  />
                  <img 
                    src="https://dashboard.gestlifesurrogacy.com/images/icons/arrow_white.svg" 
                    alt="Icon"
                    width="16" 
                    height="16" 
                    style={{ margin: '0 2px' }}
                  />
                </i>
              </Link>
            </div>
          </div>
         {/* </div>  */}
      </section>
    </>
  );
}